import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=54225aac&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=54225aac&lang=scss&scoped=true&"
import style2 from "./Footer.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54225aac",
  null
  
)

export default component.exports